import { getRuntimeConfig } from './env.config';

/**
 * Development environment configuration
 * When running in Docker, runtime configuration from window.__env
 * will override these default values.
 */

// Default configuration for development environment
const defaultConfig = {
  production: true,
  api_url: 'https://dev-api.anvyonline.com/graphql',
  noti_api_url: 'https://dev-alert.anvyonline.com/graphql',
  noti_ws_url: 'wss://dev-alert.anvyonline.com/graphql',
  rest_api_url: 'https://dev-api.anvyonline.com/api',
  theme: 'default',
  s3_url: 'https://worktraq-asset.s3.ca-central-1.amazonaws.com',
  styler_s3_url: 'https://worktraq-asset.s3.ca-central-1.amazonaws.com/wt/',
  gtp_url: 'https://dev-gtp.anvyonline.com/',
  fr_url: 'https://dev-frontend.anvyonline.com/',
  show_storefront_link: true,
  styler_url: {
    host: 'https://dev-styler.anvyonline.com/#/', // host
    b2c: 'b2ccustomertemplate', // Iframe to Open
    b2b: 'customertemplate', // Iframe to Open
  },
  styler_api_url: 'https://dev-api-styler.anvyonline.com/',
  pdf_api_url: 'https://dev-api-pdf.anvyonline.com/api/AnvyPdf/wt/',
  logo_src: 'assets/wt-logo.png',
};

// Get runtime configuration (injected at Docker container startup)
const runtimeConfig = getRuntimeConfig();

// Merge runtime config with defaults (runtime config takes precedence)
export const environment = {
  production: runtimeConfig.production ?? defaultConfig.production,
  api_url: runtimeConfig.api_url ?? defaultConfig.api_url,
  noti_api_url: runtimeConfig.noti_api_url ?? defaultConfig.noti_api_url,
  noti_ws_url: runtimeConfig.noti_ws_url ?? defaultConfig.noti_ws_url,
  rest_api_url: runtimeConfig.rest_api_url ?? defaultConfig.rest_api_url,
  theme: runtimeConfig.theme || defaultConfig.theme,
  s3_url: runtimeConfig.s3_url ?? defaultConfig.s3_url,
  styler_s3_url: runtimeConfig.styler_s3_url ?? defaultConfig.styler_s3_url,
  gtp_url: runtimeConfig.gtp_url ?? defaultConfig.gtp_url,
  fr_url: runtimeConfig.fr_url ?? defaultConfig.fr_url,
  show_storefront_link:
    runtimeConfig.show_storefront_link ?? defaultConfig.show_storefront_link,
  styler_url: {
    host: runtimeConfig.styler_url_host ?? defaultConfig.styler_url.host,
    b2c: runtimeConfig.styler_url_b2c ?? defaultConfig.styler_url.b2c,
    b2b: runtimeConfig.styler_url_b2b ?? defaultConfig.styler_url.b2b,
  },
  styler_api_url: runtimeConfig.styler_api_url ?? defaultConfig.styler_api_url,
  pdf_api_url: runtimeConfig.pdf_api_url ?? defaultConfig.pdf_api_url,
  logo_src: runtimeConfig.logo_src ?? defaultConfig.logo_src,
};
